<template>
  <div
    :id="id"
    class="modal-field-library"
    style="background-color: rgb(255,255,255);"
  >
    <div class="modal-field-title">ICONS</div>

    <div class="modal-field-content">
      <!-- Input Search -->
      <div class="input-search">
        <i class="fa fa-search" />
        <input
          v-model="searchIcon"
          type="text"
          placeholder="Search"
        >
      </div>

      <!-- Icon List -->
      <div class="wrap-field">
        <div class="icon-list">
          <div
            v-for="(icon, index) in icons"
            :key="index"
            class="list"
            @click="$emit('select-icon', icon)"
          >
            <img :src="icon.icon_grey">
          </div>
        </div>
      </div>
    </div>

    <div class="modal-field-footer">
      <button @click="$emit('close-modal')">Close</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    iconOptions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      searchIcon: '',
      icons: [],
    };
  },

  watch: {
    searchIcon(val) {
      if (val.length > 0) {
        const dataIcons = this._.cloneDeep(this.iconOptions);
        const filtered = dataIcons.filter(icon => icon.name.includes(val));
        this.icons = filtered;
      } else {
        this.icons = this.iconOptions;
      }
    },
  },

  created() {
    this.icons = this.iconOptions;
  },
};
</script>



// WEBPACK FOOTER //
// src/views/setting/jModalPageIcon.vue